import { useEffect } from 'react';
import { authProtectedRoutes, getAuthNavigationLink } from 'helpers/customNavigationRules';

import { NotificationManager, StorageManager } from '@atlas/core';

import { ALWAYS_ALLOWED_PAGES, LEAVE_SIGNUP_NOTIFICATION_ID } from 'common/constants';

import { isRegistrationFlowActive } from './useRegistrationFlowActive';

const getShouldShowLeavePopup = ({ isLeavePopupShown, isMultiStepFlow, isPartiallyRegistered }) =>
  isMultiStepFlow
    ? isRegistrationFlowActive() && (!isLeavePopupShown || isPartiallyRegistered)
    : !isLeavePopupShown && !isPartiallyRegistered;

const useLeaveSignupBlocker = ({
  enabled,
  history,
  isMultiStepFlow = false,
  isPartiallyRegistered = false,
  onLeave,
  onPopupShown,
  popupType,
  registrationStep,
  shouldBypassBlock,
}) => {
  useEffect(() => {
    if (!enabled) return;

    let leaveFired = false;

    const unblock = history.block(location => {
      if (shouldBypassBlock?.()) return;

      const isLeavePopupShown = StorageManager.getItem('leavePopupShown') === 'shown';
      const shouldShowLeavePopup = getShouldShowLeavePopup({
        isLeavePopupShown,
        isMultiStepFlow,
        isPartiallyRegistered,
      });

      const shouldBlockNavigation =
        !ALWAYS_ALLOWED_PAGES.includes(location.pathname) &&
        !location.search?.includes('cmd=signup') &&
        shouldShowLeavePopup;

      if (shouldBlockNavigation) {
        NotificationManager.display({
          data: {
            history,
            location,
            registrationStep,
            type: popupType,
            unblock,
          },
          id: LEAVE_SIGNUP_NOTIFICATION_ID,
          message: 'leaveSignup',
          type: 'leaveSignup',
        });
        onPopupShown?.();
        return false;
      }

      if (
        !ALWAYS_ALLOWED_PAGES.includes(location.pathname) &&
        !location.search?.includes('cmd=signup')
      ) {
        if (!leaveFired) {
          leaveFired = true;
          onLeave?.(`${location.pathname ?? ''}${location.search ?? ''}`);
        }

        if (authProtectedRoutes.includes(location.pathname)) {
          history.push(getAuthNavigationLink('/signup', location.pathname));
        } else {
          window.location.href = (location.pathname ?? '') + (location.search ?? '');
        }
        return false;
      }
    });

    return () => unblock();
  }, [
    enabled,
    history,
    isMultiStepFlow,
    isPartiallyRegistered,
    onLeave,
    onPopupShown,
    popupType,
    registrationStep,
    shouldBypassBlock,
  ]);
};

export default useLeaveSignupBlocker;
